import * as React from 'react';
import Box from '@mui/material/Box';
import { formatDate } from '../../../../../shared/LanguageService';
import List from '@mui/material/List';
import { ListItem } from '@mui/material';
import {
    getBusinessHours,
    getFiveMinutesSlots,
    getSlotIndex
} from './timelineCalendarHelperFuncitons';

type CalendarHeadingSectionProps = {
    selectedDate: Date;
};

const workHoursHeaderStyle = (columnStart, columnSpan) => {
    return {
        display: 'flex',
        alignItems: 'center',
        position: 'absolute',
        height: '40px',
        gridColumnStart: `${columnStart}`,
        gridColumnEnd: `${columnSpan}`,
        width: '100%',
        gridRow: '1',
        listStyle: 'none',
        fontWeight: 500,
        fontSize: '11px',
        fontFamily: 'Gilroy',
        cursor: 'default',
        paddingLeft: '1px'
    };
};

const CalendarHeadingSection = (props: CalendarHeadingSectionProps) => {
    let { selectedDate } = props;
    let businessHours = selectedDate && getBusinessHours(selectedDate);
    let fiveMinuteTimeSlots = selectedDate && getFiveMinutesSlots(selectedDate);
    let timeSlotsPerHour = 12;
    

    return (
        <List
            sx={{
                display: 'contents',
                height: '35px'
            }}
        >
            {fiveMinuteTimeSlots &&
                fiveMinuteTimeSlots.map((workHour, index) => {
                    let formattedDisplayTime = formatDate(workHour, 'kk' + ':' + 'mm');
                    let hideLastSlot = fiveMinuteTimeSlots.length - 1 === index;

                    return !hideLastSlot ? (
                        <ListItem
                            key={'header' + formattedDisplayTime}
                            value={formattedDisplayTime}
                            sx={{
                                padding: 0,
                                width: '6px',
                                height: '35px'
                            }}
                        ></ListItem>
                    ) : null;
                })}
            {businessHours &&
                businessHours.map((workHour, index) => {
                    let formattedDisplayTime = formatDate(workHour, 'kk' + ':' + 'mm');
                    let columnStart = getSlotIndex(businessHours[0], workHour) + 1;
                    let columnSpan = columnStart + timeSlotsPerHour;
                    let hideLastSlot = businessHours.length - 1 === index;
                    return !hideLastSlot ? (
                        <Box
                            key={'header' + formattedDisplayTime}
                            sx={workHoursHeaderStyle(columnStart, columnSpan)}
                        >
                            {formattedDisplayTime}
                        </Box>
                    ) : null;
                })}
        </List>
    );
};

export default CalendarHeadingSection;
